import React from 'react';
import styled from 'styled-components';
import { isMergedNode, minDimension } from './utils';
import { IMask, ISankeyNode } from './interfaces';
import SankeyNodeTooltip from './SankeyNodeTooltip';
import isNil from 'lodash/isNil';
import SankeyNodeSummaryTooltip from './SankeyNodeSummaryTooltip';
import SankeyNodeTooltipContainer from './SankeyNodeTooltipContainer';
import { ChartMode } from '../types';
const PatternedRect = styled.rect<{ $mask?: IMask }>`
  ${({ $mask }) => $mask && `mask: url(#${$mask});`}
`;

interface IProps {
  color: string;
  node: ISankeyNode;
  mode: ChartMode;
  isBase: boolean;
  isObserveMode: boolean;
  onMouseOver: (index: number) => void;
  onMouseLeave: (index: number) => void;
  onNodeClick: (
    ev: React.MouseEvent<SVGElement, MouseEvent>,
    index: number,
  ) => void;
}

export default ({
  color,
  node,
  mode,
  isBase,
  isObserveMode,
  onMouseOver,
  onMouseLeave,
  onNodeClick,
}: IProps) => {
  const { index, x0, x1, y0, y1, textVisible, visible: nodeVisible } = node;

  let mask: IMask | undefined;
  if (isMergedNode(node)) {
    mask = IMask.MASK_STRIPE_ID;
  } else if (node.groupIndex > 0) {
    mask = IMask.MASK_ALT_ID;
  }

  let tooltip: JSX.Element | undefined;
  if (nodeVisible) {
    if (
      isObserveMode ||
      textVisible ||
      isBase ||
      (!isNil(node.nodeGroup) && node.nodeGroup.length === 1)
    ) {
      tooltip = (
        <SankeyNodeTooltip
          node={node}
          isBase={isBase}
          color={color}
          isObserveMode={isObserveMode}
        />
      );
    } else if (
      !isNil(node.nodeGroup) &&
      node.nodeGroup.length > 1 &&
      !isObserveMode
    ) {
      tooltip = (
        <SankeyNodeSummaryTooltip nodes={node.nodeGroup} color={color} />
      );
    }
  }

  return (
    <>
      <PatternedRect
        $mask={mask}
        x={x0}
        y={y0}
        cursor={'pointer'}
        width={x1 - x0}
        height={minDimension(y1 - y0)}
        fill={color}
        opacity={nodeVisible ? 1 : 0.1}
        onMouseEnter={() => onMouseOver(index)}
        onMouseOut={() => onMouseLeave(index)}
        onClick={(ev) => onNodeClick(ev, index)}
      />
      {!isNil(tooltip) && (
        <SankeyNodeTooltipContainer
          x={x0}
          y={y0}
          isObserveMode={isObserveMode}
          mode={mode}
        >
          {tooltip}
        </SankeyNodeTooltipContainer>
      )}
    </>
  );
};
